// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"3189":"ec25f267","8262":"ec25f267"}[chunkId] + ".chunk.css";
};